import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FlexModule } from '@ngbracket/ngx-layout';
import { L10N_CONFIG, L10N_LOCALE, L10nConfig, L10nLocale, L10nTranslatePipe, L10nTranslationService } from 'angular-l10n';
import { APIConfigService } from '../../api.config.service';
import { AngularMaterial2Module } from '../../app.module.material';
import { AuthService } from '../../shared/auth.service';
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
import { LoggerService } from '../../shared/logger.service';
import { KontaktFormularModel } from './kontaktformular.model';
import { Kernantwort } from '../../shared/response/kernantwort.model';


const PATH_FILE = 'app/protected/kontaktformular/kontaktformular.component.ts';
const OBJ_LNG_NAME = 'kontaktformular';
const BACKEND_PATH_PREFIX = 'kontakt/senden';

@Component({
    selector: 'oase-kontaktformular',
    templateUrl: './kontaktformular.component.html',
    styleUrls: ['./kontaktformular.component.css'],
    standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule, RouterLink, ReactiveFormsModule]
})
export class KontaktFormularComponent {
    contactForm: FormGroup;
    files: File[] = [];
    maxFileSize: number = 20971520; // 20 MB in bytes
    PATH_FILE: string = 'app/protected/kontaktformular/kontaktformular.component.ts';
    OBJ_LNG_NAME: string = 'kontaktformular';
    BACKEND_PATH_PREFIX: string = 'kontaktformular';
    fehlerMain: Kernantwort;
    @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public breadcrumbService: BreadcrumbService,
        public snackBar: MatSnackBar,
        public authService: AuthService,
        public apiConfigService: APIConfigService,
        public http: HttpClient,
        @Inject(L10N_LOCALE) public locale: L10nLocale,
        @Inject(L10N_CONFIG) private config: L10nConfig,
        public translation: L10nTranslationService,
        public title: Title,
        public _logger: LoggerService,
        public fb: FormBuilder) {
        this.contactForm = this.fb.group({
            subject: ['', Validators.required],
            message: ['', Validators.required],
            file: [null]
        });
        this.PATH_FILE = PATH_FILE;
        this.OBJ_LNG_NAME = OBJ_LNG_NAME;
        this.BACKEND_PATH_PREFIX = BACKEND_PATH_PREFIX;
    }

    onFileSelected(event: any) {
        const selectedFiles: File[] = event.target.files;
        let totalSize = this.files.reduce((acc, file) => acc + file.size, 0);
        this._logger.debug(PATH_FILE+' - total size of current files: '+totalSize);

        for (let file of selectedFiles) {
            if (this.files.length >= 3) {
                this.snackBar.open(this.translation.translate('kontaktformular.dateizahlueberschritten'), 'OK', { duration: 3000 });
                break;
            }
            if (totalSize + file.size > this.maxFileSize) {
                this.snackBar.open(this.translation.translate('kontaktformular.zugross'), 'OK', { duration: 3000 });
                break;
            }
            this.files.push(file);
            totalSize += file.size;
        }
    }

    deleteFile(index: number) {
        this.files.splice(index,1);
    }

    onSubmit() {
        if (!this.contactForm.valid) {
            this.snackBar.open(this.translation.translate('kontaktformular.pflichtfelder'), 'OK', { duration: 3000 });
            return;
        }
        const myHeader = new HttpHeaders({
            'Accept': 'application/json'  // Explicitly accept JSON response
          });
        const formData = new FormData();
        formData.append('betreff', this.contactForm.value.subject);
        formData.append('nachricht', this.contactForm.value.message);
        this.files.forEach((file, index) => {
            formData.append('files', file, file.name);
            this._logger.debug(PATH_FILE+' - formData file appended: files['+index+'] with name: '+file.name);
        });
        this.http.post(this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX, formData, {headers: myHeader}).subscribe({
            next: (response: KontaktFormularModel) => {
                if (response.betreff) {
                    this.snackBar.open(this.translation.translate('kontaktformular.uebermittelt'), 'OK', { duration: 10000 });
                    this.contactForm.reset();
                    this.files = [];
                }
            },
            error: () => {
                this.fehlerMain=new Kernantwort();
                this.fehlerMain.messagehtml=this.translation.translate('kontaktformular.fehler');
                this.snackBar.open(this.translation.translate('kontaktformular.fehler'), 'OK', { duration: 5000 });
            }
        });
    }

    triggerFileClick(): void {
        this.fileInput.nativeElement.click();
      }

    get subject(): AbstractControl {
        return this.contactForm.get('subject');
    }
    
    get nachricht(): AbstractControl {
        return this.contactForm.get('message');
    }
}